<template>
  <form-select
    class="special-area-select"
    v-model="val"
    :options="options"
    @change="change"
    v-on="$listeners"
  ></form-select>
</template>
<script>
export default {
  name: 'special-area-select',
  props: {
    area: Array,
    value: [String, Number],
  },
  model: {
    prop: 'value',
    event: 'setval',
  },
  computed: {
    val: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('setval', newVal)
      },
    },
  },
  data() {
    return {
      options: [],
      vermap: {},
    }
  },
  methods: {
    calcAreaOptions() {
      var options = []
      this.vermap = []
      for (var item of this.area) {
        this.vermap[item.area] = item.versions
        options.push({
          packid: item.packid,
          area: item.area,
          label: item.area,
          value: item.area,
        })
      }
      this.options = options
      this.val = null
      if (options.length > 0) {
        this.$nextTick(() => {
          this.val = options[0].value
          this.$emit('outVersion', options[0], this.vermap[options[0].value])
        })
      }
    },
    change(newVal) {
      for (var item of this.options) {
        if (item.value == newVal) {
          this.$emit('outVersion', item, this.vermap[item.value])
        }
      }
    },
  },
  watch: {
    area() {
      this.calcAreaOptions()
    },
  },
}
</script>
<style lang="less">
.special-area-select {
  width: 100px;
}
</style>